import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/results/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  },
  component: () => null,
});
